import "./IInvestWelcomeWizard.scss";

export class IInvestWelcomeWizardController {

    static id = "iInvestWelcomeWizardCtl";

    legals = null;

    /** @ngInject */
    constructor($http, userConfig, $window, $uibModalInstance) {
        this.$http = $http;
        this.userConfig = userConfig;
        this.$window = $window;
        this.$uibModalInstance = $uibModalInstance;
    }

    $onInit() {
        this.initLegalContent();
    }

    async initLegalContent() {
        const response = await this.$http.get("app/layout/legal/legal.json");
        const data = response.data;

        function htmlify(value) {
            const bold = /“(.*?)”/g;
            const italic = /‘(.*?)’/g;
            return value.replace(bold, "<b>“$1”</b>").replace(italic, "<i>‘$1’</i>");
        }

        this.legals = data[this.userConfig.broker] || data.TF;

        this.legals.introParagraphs = this.legals.introParagraphs.map(htmlify);
        this.legals.sections.forEach((s) => s.content = htmlify(s.content));
    }

    async acceptTerms() {
        await this.$http.put("/tradefloor/api/user/legal/terms");
        await this.$http.put("/tradefloor/api/user/onboard");
        this.$uibModalInstance.close();
    }

    async declineTerms() {
        const response = await this.$http.get("/tradefloor/api/logout");
        this.$window.location.href = response.headers("location") || "/";
    }
}
